











































import Vue from 'vue';
import { ICalendarDoor } from '@/common/interfaces/announcement-bar.interface';
import ChristmasCalendarButton from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarButton.vue';
import ChristmasCalendarContentDoor from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarContentDoor.vue';
import ChristmasCalendarProductDoor from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarProductDoor.vue';
import ValidationHelper from '@/helpers/ValidationHelper';
import ChristmasCalendarGiveawayDoor
  from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarGiveawayDoor.vue';
import { ECalendarDoorTypes } from '@/common/enums/announcement-bar.enum';

interface IChristmasCalendarMobileViewComponent {
  ECalendarDoorTypes: typeof ECalendarDoorTypes;
}

export default Vue.extend({
  name: `ChristmasCalendarMobileView`,
  components: {
    ChristmasCalendarButton,
    ChristmasCalendarContentDoor,
    ChristmasCalendarGiveawayDoor,
    ChristmasCalendarProductDoor,
  },
  data(): IChristmasCalendarMobileViewComponent {
    return {
      ECalendarDoorTypes,
    };
  },
  computed: {
    showDoorContent(): boolean {
      return !!this.content;
    },
  },
  props: {
    content: {
      default: null,
      type: Object as () => ICalendarDoor,
      validator: prop => ValidationHelper.isObjectOrNull(prop),
    },
    day: {
      required: true,
      type: Number,
    },
    logoPath: {
      required: true,
      type: String,
    },
    showReadMore: {
      default: false,
      type: Boolean,
    },
  },
});
